import * as types from './spendingWatchlistTypes';

export function transformSpendingWatchListToRequestData(spendingWatchList) {
  return {
    id: spendingWatchList.id,
    clientId: spendingWatchList.clientId,
    isDeleted: spendingWatchList.isDeleted,
    name: spendingWatchList.name,
    filterId: spendingWatchList.filterId,
    targetAmount: spendingWatchList.targetAmount,
    resetTargetAmount: spendingWatchList.resetTargetAmount,
    emoji: spendingWatchList.emoji,
    period: spendingWatchList.period,
    startDate: spendingWatchList.startDate,
    endDate: spendingWatchList.endDate,
  };
}

export function transformResponseToSpendingWatchLists(response) {
  return response?.data?.resources?.map((data) =>
    types.mkSpendingWatchList({
      id: data.id,
      clientId: data.clientId,
      isDeleted: data.isDeleted,
      name: data.name,
      filterId: data.filterId,
      thisMonth: data.thisMonth,
      yearToDate: data.yearToDate,
      monthlyTrend: data.monthlyTrend,
      numMonthlyTrendMonths: data.numMonthlyTrendMonths,
      monthSpendingProjection: data.monthSpendingProjection,
      targetAmount: data.targetAmount,
      emoji: data.emoji,
      createdAt: data.createdAt,
      period: data.period,
      startDate: data.startDate,
      endDate: data.endDate,
      spentSoFar: data.spentSoFar,
    }),
  );
}
